/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConflictContractDto } from './conflictContractDto.model';
import { ConflictParcelDto } from './conflictParcelDto.model';
import { ConflictSubjectDto } from './conflictSubjectDto.model';


export interface ConflictTypeContractDto { 
    contract?: ConflictContractDto;
    from?: string;
    parcels?: Array<ConflictParcelDto>;
    subjects?: Array<ConflictSubjectDto>;
    to?: string;
}

